import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Calendar } from "lucide-react";
import { PERIOD_OPTIONS, getRange } from "@/lib/period";

export default function PeriodFilter({ periodKey, setPeriodKey, custom, setCustom, onChange }) {
  const handleKey = (k) => {
    setPeriodKey(k);
    if (k !== "custom") onChange(getRange(k));
  };
  const handleCustom = (field, v) => {
    const nc = { ...custom, [field]: v };
    setCustom(nc);
    if (nc.start && nc.end) onChange(getRange("custom", nc));
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-filter">
      <Select value={periodKey} onValueChange={handleKey}>
        <SelectTrigger className="w-[180px] bg-white" data-testid="period-select">
          <Calendar className="mr-2 h-4 w-4 text-slate-400" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PERIOD_OPTIONS.map((o) => (<SelectItem key={o.key} value={o.key}>{o.label}</SelectItem>))}
        </SelectContent>
      </Select>
      {periodKey === "custom" && (
        <div className="flex items-center gap-2">
          <Input type="date" className="w-[150px] bg-white" value={custom?.start || ""} onChange={(e) => handleCustom("start", e.target.value)} />
          <span className="text-slate-400">–</span>
          <Input type="date" className="w-[150px] bg-white" value={custom?.end || ""} onChange={(e) => handleCustom("end", e.target.value)} />
        </div>
      )}
    </div>
  );
}
